// import { types } from "@babel/core";
import {
  contentTypeSlugToName,
  contentTypeImages
} from '../../src/constants/contentTypeMap';
const decodeHtml = (html) => {
  if (!html) return '';
  const txt = document.createElement("textarea");
  txt.innerHTML = html;
  return txt.value;
};


export const mapCultureCustomsListData = (data, included = []) => {
  if (!Array.isArray(data)) return [];

  const validIncluded = Array.isArray(included) ? included : [];

  // Generic lookup helper
  const buildLookupMap = (type) =>
    validIncluded
      .filter((item) => item.type === type)
      .reduce((acc, curr) => {
        acc[curr.id] = curr.attributes?.name || `Unknown ${type}`;
        return acc;
      }, {});
  const getRelationshipIds = (item, taxonomy) => {
    const rel = item.relationships?.[taxonomy];
    return Array.isArray(rel) ? rel.map(r => r.id) : [];
  };

  const seasonMap = buildLookupMap('ps-seasons');
  const nationalityMap = buildLookupMap('ps-nationalities');
  const categoryMap = buildLookupMap('ps-categories');

  //  Transform the main data
  return data.map(item => {
    const rawType = item.attributes?.ps_content_type?.[0] || '';
    const contentTypeName = contentTypeSlugToName[rawType] || '';
    const apiImage = item.attributes?.image?.large?.trim();
    const fallbackImage = contentTypeImages[contentTypeName] || `${process.env.PUBLIC_URL}/media/images/culture-customs.jpg`;
    const imageUrl = apiImage ? apiImage : fallbackImage;


    console.log(`[Image Assignment] ${item.attributes?.title} | Type: ${contentTypeName}`);
    console.log(`→ Using Image: ${imageUrl} (${apiImage ? 'API Image' : 'Static Fallback'})`);

    const seasonIds = getRelationshipIds(item, 'ps-seasons');
    const nationalityIds = getRelationshipIds(item, 'ps-nationalities');
    const categoryIds = getRelationshipIds(item, 'ps-categories');
    return {
      id: item.id,
      title: item.attributes?.title || 'Untitled',
      imageUrl,
      slug: item.attributes?.slug || '',
      favorite: item.attributes?.favorite || false,
      psContentType: item.attributes?.ps_content_type || [], //  Ensure category is included
      psAuthor: item.attributes?.ps_authors || [],
      catList: [
        ...seasonIds.map(season => seasonMap[season.id] || ''),
        ...nationalityIds.map(nationality => nationalityMap[nationality.id] || ''),
        ...categoryIds.map(category => categoryMap[category.id] || ' '),
      ],
    };
  });
};

export const mapCatchesisListData = (data, included = []) => {
  if (!Array.isArray(data)) return [];

  const validIncluded = Array.isArray(included) ? included : [];

  //  Create lookup maps for seasons & nationalities
  const seasonMap = validIncluded
    .filter(item => item.type === 'ps-seasons')
    .reduce((acc, season) => {
      acc[season.id] = season.attributes?.name || 'Unknown Season';
      return acc;
    }, {});

  const nationalityMap = validIncluded
    .filter(item => item.type === 'ps-nationalities')
    .reduce((acc, nationality) => {
      acc[nationality.id] = nationality.attributes?.name || 'Unknown Nationality';
      return acc;
    }, {});

  //  Transform the main data
  return data.map(item => {
    const seasonIds = item.relationships?.['ps-seasons'] || [];
    const nationalityIds = item.relationships?.['ps-nationalities'] || [];

    return {
      id: item.id,
      title: item.attributes?.title || 'Untitled',
      slug: item.attributes?.slug || '',
      favorite: item.attributes?.favorite || false,
      imageUrl: item.attributes?.image || `${process.env.PUBLIC_URL}/media/images/group-of-catechesis-title.jpeg`,
      catList: [
        ...seasonIds.map(season => seasonMap[season.id] || 'Unknown Season'),
        ...nationalityIds.map(nation => nationalityMap[nation.id] || 'Unknown Nationality'),
      ],
    };
  });
};

export const mapPrayerRitesListData = (data, included = []) => {
  if (!Array.isArray(data)) return [];

  const validIncluded = Array.isArray(included) ? included : [];


  const createLookup = (type) =>
    validIncluded
      .filter(item => item.type === type)
      .reduce((acc, curr) => {
        acc[curr.id] = curr.attributes?.name || `Unknown ${type}`;
        return acc;
      }, {});

  const seasonMap = createLookup('ps-seasons');
  const prayerTypeMap = createLookup('ps-prayer-types');
  const prayerFormatMap = createLookup('ps-prayer-formats');

  //  Transform the main data
  return data.map(item => {
    const seasonIds = item.relationships?.['ps-seasons'] || [];
    const typeIds = item.relationships?.['ps-prayer-types'] || [];
    const formatIds = item.relationships?.['ps-prayer-formats'] || [];
    const imageUrl = item?.attributes?.image?.medium || `${process.env.PUBLIC_URL}/media/images/group-of-catechesis-title.jpeg`

    // console.log("Season Map:", seasonMap);
    // console.log("Season Relationships:", seasonIds);
    return {
      id: item.id,
      title: item.attributes?.title || 'Untitled Prayer',
      slug: item.attributes?.slug || '',
      imageUrl,
      excerpt: item.attributes?.excerpt || 'No description available.',
      favorite: item.attributes?.favorite || false,
      catList: [
        ...seasonIds.map(season => seasonMap[season.id] || ''),
        ...typeIds.map(type => prayerTypeMap[type.id] || ''),
        ...formatIds.map(format => prayerFormatMap[format.id] || ''),
      ],
    };
  });
};

export const mapCatecheticalCoursesListData = (data) => {
  if (!Array.isArray(data)) return [];

  return data.map(item => {
    const estimatedTimeInSeconds = parseInt(item.attributes?.["ps-estimated-time"]?.[0] || "0", 10);
    const hours = Math.floor(estimatedTimeInSeconds / 3600);
    const minutes = Math.round((estimatedTimeInSeconds % 3600) / 60);
    let readableTime = '';

    if (hours > 0) {
      readableTime = `About ${hours} hr${hours > 1 ? 's' : ''}`;
    } else if (minutes > 0) {
      readableTime = `About ${minutes} min`;
    }

    return {
      id: item.id,
      title: item.attributes?.name || 'Untitled Course',
      slug: item.attributes?.slug || '',
      // description: item.attributes?.description || '',
      count: item.attributes?.count || 0,
      imageUrl: item?.attributes?.["ps-course-image"]?.[0] &&
        item.attributes["ps-course-image"][0] !== ''
        ? item.attributes["ps-course-image"]
        : `${process.env.PUBLIC_URL}/media/images/group-of-catechesis-title.jpeg`,
      openTeg: 'Recently Opened',
      catechesis: `Catechesis`,
      aboutHours: readableTime,
      catList: [],
      favorite: item.attributes?.favorite || false,

    }
  });
};


export const mapSingleCatechesisCourseData = (data = {}) => {
  if (!data || typeof data !== 'object') return null;
  const attributes = data.attributes || {};

  const estimatedTimeInSeconds = parseInt(data.attributes?.["ps-estimated-time"]?.[0] || "0", 10);
  const hours = Math.floor(estimatedTimeInSeconds / 3600);
  const minutes = Math.round((estimatedTimeInSeconds % 3600) / 60);

  let readableTime = '';
  if (hours > 0) {
    readableTime = `About ${hours} hr${hours > 1 ? 's' : ''}`;
  } else if (minutes > 0) {
    readableTime = `About ${minutes} min`;
  }

  return {
    id: data.id,
    name: attributes?.name || 'Untitled Course',
    description: attributes?.description || 'No description available.',
    count: typeof attributes?.count === 'number' ? attributes.count : 0,
    aboutHours: readableTime,
    favorite: attributes?.favorite || false,
    imageUrl: Array.isArray(attributes?.["ps-course-image"]) && attributes["ps-course-image"][0]
      ? attributes["ps-course-image"][0]
      : `${process.env.PUBLIC_URL}/media/images/group-of-catechesis-title.jpeg`,
  };
};



export const mapCatechesisListData = (data = []) => {
  if (!Array.isArray(data)) return [];

  return data.map(item => ({
    id: item.id,
    title: item.attributes?.title || 'Untitled Catechesis',
    slug: item.attributes?.slug || '',
    excerpt: item.attributes?.excerpt,
    favorite: item.attributes?.favorite || false,
    imageUrl: item?.attributes?.["ps-course-image"]?.[0] &&
      item.attributes["ps-course-image"][0] !== ''
      ? item.attributes["ps-course-image"]
      : `${process.env.PUBLIC_URL}/media/images/group-of-catechesis-title.jpeg`,
  }));
};

export const mapSingleCatechesisData = (data, included = []) => {
  if (!data || typeof data !== 'object') return null;

  const validIncluded = Array.isArray(included) ? included : [];

  //  Create a lookup map for `ps-catechetical-courses`
  const courseMap = validIncluded
    .filter(item => item.type === 'ps-catechetical-courses')
    .reduce((acc, course) => {
      acc[course.id] = course.attributes?.name || 'Unknown Course';
      return acc;
    }, {});

  //  Extract related course ID from relationships
  const courseIds = data.relationships?.['ps-catechetical-courses'] || [];
  const relatedCourses = courseIds.length
    ? courseIds.map(course => courseMap[course.id] || 'Unknown Course')
    : ['Static Catechesis Group Name']; //  Static fallback if no related course found

  // Extracted Links
  const links = data.links || {};
  const previous = Array.isArray(links.previous) ? links.previous : [];
  const next = Array.isArray(links.next) ? links.next : [];


  //  Transform the main data
  return {
    id: data.id,
    title: data.attributes?.title || 'Untitled Catechesis',
    slug: data.attributes?.slug || '',
    excerpt: data.attributes?.excerpt || 'No description available.',
    content: data.attributes?.content || '',
    imageUrl: data.attributes?.image || `${process.env.PUBLIC_URL}/media/images/default-catechesis.jpeg`,
    favorite: data.attributes?.favorite || false,
    createdAt: data.attributes?.created_at || '',
    updatedAt: data.attributes?.updated_at || '',
    courseList: relatedCourses,
    courseId: courseIds[0]?.id,
    links: {
      self: links?.self || '',
      previous,
      next
    }
  };
};

// For PageFavorites - when mapping many devotions
export const mapSingleDevotionsListData = (items = [], included = []) => {
  return items.map((item) => {
    const attributes = item?.attributes || {};

    const safeJoin = (input) =>
      Array.isArray(input)
        ? input.join('')
        : typeof input === 'string'
          ? input
          : '';

    return {
      id: item?.id,
      title: attributes.title || 'Untitled',
      slug: attributes.slug || '',
      excerpt: attributes.excerpt || '',
      imageUrl: attributes?.image?.medium || `${process.env.PUBLIC_URL}/media/images/group-of-catechesis-title.jpeg`,
      english: safeJoin(attributes.ps_english_long_text),
      latin: safeJoin(attributes.ps_latin_long_text),
      date: attributes.created_at,
      favorite: Boolean(attributes.favorite),
    };
  });
};

export const mapSingleDevotionsData = (response) => {
  const item = response?.data;
  const attributes = item?.attributes || {};

  const safeJoin = (input) =>
    Array.isArray(input)
      ? input.join('')
      : typeof input === 'string'
        ? input
        : '';

  return {
    id: item?.id,
    title: attributes.title || 'Untitled',
    slug: attributes.slug || '',
    excerpt: attributes.excerpt || '',
    imageUrl: attributes?.image?.medium || `${process.env.PUBLIC_URL}/media/images/group-of-catechesis-title.jpeg`,
    english: safeJoin(attributes.ps_english_long_text),
    latin: safeJoin(attributes.ps_latin_long_text),
    date: attributes.created_at,
    favorite: Boolean(attributes.favorite),
  };
};

export const mapSingleMeditationData = (apiData) => {
  const attributes = apiData?.data?.attributes || {};
  const relationships = apiData?.data?.relationships || {};
  const included = apiData?.included || [];
  let author = null;
  let season = null;
  const authorRel = relationships['ps-authors']?.[0];
  if (authorRel) {
    author = included.find(
      (item) => item.type === 'ps-authors' && item.id === authorRel.id
    )?.attributes;
  }

  const seasonRel = relationships['ps-seasons']?.[0];
  if (seasonRel) {
    season = included.find(
      (item) => item.type === 'ps-seasons' && item.id === seasonRel.id
    )?.attributes?.name;
  }

  // Image (media)
  let imageUrl = '';
  const mediaRel = relationships['featured-media']?.data || relationships['media']?.data;
  if (mediaRel) {
    const mediaItem = included.find(
      (item) => item.type === mediaRel.type && item.id === mediaRel.id
    );
    imageUrl = mediaItem?.attributes?.url || '';
  }

  return {
    id: apiData?.data?.id || null,
    slug: attributes.slug || '',
    title: attributes.title || '',
    excerpt: attributes.excerpt || '',
    content: attributes.content || '',
    favorite: attributes.favorite || false,
    author: author,
    season: season,
    imageUrl: attributes?.image?.medium || `${process.env.PUBLIC_URL}/media/images/group-of-catechesis-title.jpeg`,
    sourceAttribution: attributes.ps_source_attribution?.[0] || '',
    sourceUrl: attributes.ps_source_url?.[0] || '',
    audio: {},
  };
};




export const mapSinglePrayerData = (data, included = []) => {
  if (!data || typeof data !== 'object') return null;

  const validIncluded = Array.isArray(included) ? included : [];

  const courseMap = validIncluded
    .filter(item => item.type === 'ps-prayer-types')
    .reduce((acc, course) => {
      acc[course.id] = course.attributes?.name || 'Unknown Course';
      return acc;
    }, {});

  const seasonMap = validIncluded
    .filter(item => item.type === 'ps-seasons')
    .reduce((acc, season) => {
      acc[season.id] = season.attributes?.name || 'Unknown Season';
      return acc;
    }, {});

  const nationalityMap = validIncluded
    .filter(item => item.type === 'ps-nationalities')
    .reduce((acc, nationality) => {
      acc[nationality.id] = nationality.attributes?.name || 'Unknown Nationality';
      return acc;
    }, {});

  const authorMap = validIncluded
    .filter(item => item.type === 'ps-authors')
    .reduce((acc, author) => {
      acc[author.id] = {
        name: author.attributes?.name || 'Unknown Author',
        slug: author.attributes?.slug || '',
        count: author.attributes?.count || 0
      }
      return acc;
    }, {});

  const seasonIds = data.relationships?.['ps-seasons'] || [];
  const nationalityIds = data.relationships?.['ps-nationalities'] || [];
  const authorIds = data.relationships?.['ps-authors'] || [];

  const firstAuthorId = authorIds?.[0]?.id;
  const author = firstAuthorId ? authorMap[firstAuthorId] : {
    name: '',
    slug: '',
    count: 0
  };

  //  Extract attributes
  const attributes = data.attributes || {};

  console.log('Season IDs:', seasonIds);

  const isValidAudioUrl = url => typeof url === 'string' && /\.(mp3|ogg|wav)$/i.test(url);

  return {
    id: data.id,
    title: decodeHtml(attributes?.title || 'Untitled Prayer'),
    slug: attributes?.slug || '',
    excerpt: decodeHtml(attributes?.excerpt || 'No excerpt available.'),
    content: decodeHtml(attributes?.content || ''),
    imageUrl: attributes?.image?.large || `${process.env.PUBLIC_URL}/media/images/default-prayer.jpeg`,
    favorite: Boolean(attributes?.favorite),
    createdAt: attributes?.created_at || '',
    updatedAt: attributes?.updated_at || '',
    latin_content: attributes?.ps_latin_prayer?.length > 0 ? decodeHtml(attributes.ps_latin_prayer[0]) : null,
    source: attributes.ps_source_attribution[0] || "UnKnown Source",
    author,
    english_audio: Array.isArray(attributes?.ps_english_prayer_audio_url)
      ? attributes.ps_english_prayer_audio_url[0]
      : attributes?.ps_english_prayer_audio_url || '',

    latin_audio: Array.isArray(attributes?.ps_latin_prayer_audio_url)
      ? attributes.ps_latin_prayer_audio_url[0]
      : attributes?.ps_latin_prayer_audio_url || '',

    catList: [
      ...seasonIds.map(season => seasonMap[season.id] || 'Unknown Season'),
      ...nationalityIds.map(nation => nationalityMap[nation.id] || 'Unknown Nationality'),
    ],

  };
};

export const mapSingleCultureData = (data, included = []) => {
  if (!data || typeof data !== 'object') return null;

  const validIncluded = Array.isArray(included) ? included : [];

  const courseMap = validIncluded
    .filter(item => item.type === 'ps-prayer-types')
    .reduce((acc, course) => {
      acc[course.id] = course.attributes?.name || 'Unknown Course';
      return acc;
    }, {});

  const seasonMap = validIncluded
    .filter(item => item.type === 'ps-seasons')
    .reduce((acc, season) => {
      acc[season.id] = season.attributes?.name || 'Unknown Season';
      return acc;
    }, {});

  const nationalityMap = validIncluded
    .filter(item => item.type === 'ps-nationalities')
    .reduce((acc, nationality) => {
      acc[nationality.id] = nationality.attributes?.name || 'Unknown Nationality';
      return acc;
    }, {});

  const authorsMap = validIncluded
    .filter(item => item.type === 'ps-authors')
    .reduce((acc, authors) => {
      acc[authors.id] = authors.attributes?.name || 'Unknown Author';
      return acc;
    }, {});




  const seasonIds = data.relationships?.['ps-seasons'] || [];
  const nationalityIds = data.relationships?.['ps-nationalities'] || [];
  const authorsIds = data.relationships?.['ps-authors'] || [];



  //  Extract attributes
  const attributes = data.attributes || {};

  return {
    id: data.id,
    title: decodeHtml(attributes?.title || 'Untitled Prayer'),
    slug: attributes?.slug || '',
    imageUrl: attributes?.image || `${process.env.PUBLIC_URL}/media/images/default-prayer.jpeg`,
    favorite: Boolean(attributes?.favorite),
    createdAt: attributes?.created_at || '',
    updatedAt: attributes?.updated_at || '',
    source: attributes.ps_source_attribution || '',
    catList: [
      ...seasonIds.map(season => seasonMap[season.id] || 'Unknown Season'),
      ...nationalityIds.map(nation => nationalityMap[nation.id] || 'Unknown Nationality'),
      ...authorsIds.map(author => authorsMap[author.id] || 'Unknown Author'),
    ],

  };
};
